import React from 'react';

const PRICING = {
  91: 30,
  181: 50,
  365: 60
};

function PricingSummary({ selectedBoards, duration, legacyBalance = 0 }) {
  if (selectedBoards.length === 0) return null;

  // Calculate pricing
  const pricePerBoard = PRICING[duration];
  const boardCount = selectedBoards.length;
  const subtotal = boardCount * pricePerBoard;
  const discount = boardCount >= 2 ? subtotal * 0.10 : 0;
  const afterDiscount = subtotal - discount;
  const balanceApplied = Math.min(legacyBalance, afterDiscount);
  const total = Math.max(0, afterDiscount - balanceApplied);

  return (
    <div className="col-span-6">
      <div className="bg-red-50 border-2 border-red-50 rounded-lg p-4 mt-6">
        <h3 className="font-bold text-gray-900 mb-3 text-base">Pricing Summary</h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between text-gray-700">
            <span>{boardCount} board{boardCount > 1 ? 's' : ''} × ${pricePerBoard}</span>
            <span className="font-medium">${subtotal.toFixed(2)}</span>
          </div>
          {discount > 0 && (
            <div className="flex justify-between text-green-600 font-medium">
              <span>Multi-board discount (10%)</span>
              <span>-${discount.toFixed(2)}</span>
            </div>
          )}
          {balanceApplied > 0 && (
            <div className="flex justify-between text-primary font-medium">
              <span>Account balance</span>
              <span>-${balanceApplied.toFixed(2)}</span>
            </div>
          )}
          <div className="flex justify-between font-bold text-primary pt-3 border-t-2 border-red-200 mt-2 text-lg">
            <span>Total</span>
            <span>${total.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PricingSummary;
